import { WORK_DAYS } from 'entities/teacher-workload/form/model/work-days-config';
import type { TeacherWorkloadWorkDayFormRow } from 'entities/teacher-workload/form/types';
import type { WorkDayTableRecord } from './types';

export const MODE_OPTIONS: { label: string; value: TeacherWorkloadWorkDayFormRow['mode'] }[] = [
  { label: 'Выходной', value: 'off' },
  { label: 'Полный день', value: 'unlimited' },
  { label: 'Время', value: 'interval' },
];

export const WORK_DAY_TABLE_ROWS: WorkDayTableRecord[] = WORK_DAYS.map((day, index) => ({
  key: day.value,
  index,
  dayLabel: day.label,
}));
